export default "__VITE_ASSET__Cnkueu2Z__"